<template>

  <div class="wrap dashboard">
    <div class="dashboard__wrap">
      <h2 class="dashboard__head">All-in Dashboard</h2>
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
  </div>

</template>

<script>
export default {}
</script>
